import {
  AcUnit,
  Block,
  CheckCircleOutline,
  Delete,
  Pending,
  Public,
  Schedule,
} from '@mui/icons-material';
import { pluralize } from '@prismamedia/one-components';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import React from 'react';
import { History } from '.';

export interface StatusesType {
  id: string;
  label: string;
  icon: React.ReactNode | React.FunctionComponent<any>;
  color: string;
}
export const DEFAULT_STATUSES: StatusesType[] = [
  {
    id: 'Published',
    label: 'Publiée',
    icon: Public,
    color: '#02a8f3',
  },
  {
    id: 'Scheduled',
    label: 'Programmée',
    icon: Schedule,
    color: '#eb2649',
  },
  {
    id: 'Ready',
    label: 'Prêt',
    icon: CheckCircleOutline,
    color: '#009587',
  },
  {
    id: 'Frozen',
    label: 'Gelé',
    icon: AcUnit,
    color: '#02a8f3',
  },
  {
    id: 'Draft',
    label: 'Brouillon',
    icon: Block,
    color: '#02a8f3',
  },
  {
    id: 'Deleted',
    label: 'Corbeille',
    icon: Delete,
    color: '#02a8f3',
  },
  {
    id: 'Pending',
    label: 'En traitement',
    icon: Pending,
    color: '#02a8f3',
  },
];

export const getHistoryInfos = (
  history: History,
  nextHistory?: History,
  createLabel?: string,
  statuses?: StatusesType[],
): { label?: string; value?: string } => {
  if (!nextHistory) {
    return {
      label: createLabel,
      value: format(new Date(history.createdAt), 'dd/MM/yyyy à HH:mm', {
        locale: fr,
      }),
    };
  } else if (history.status !== nextHistory.status) {
    return {
      label: 'Modification du status',
      value: statuses?.find((status) => status.id === history.status)?.label,
    };
  } else if (history?.data?.tabs?.length !== nextHistory.data?.tabs?.length) {
    if (history.data?.tabs.length < nextHistory.data?.tabs?.length) {
      const nbDeletedSections =
        history.data?.tabs.length - nextHistory.data?.tabs?.length;
      return {
        label: "Suppression d'un ou de plusieurs section(s)",
        value: `${nbDeletedSections} ${pluralize(
          'contenu',
          nbDeletedSections,
        )} ${pluralize('suprimé', nbDeletedSections)}`,
      };
    }

    const nbAddedSections =
      history.data?.tabs.length - nextHistory.data?.tabs?.length;
    return {
      label: "Ajout d'un ou de plusieurs contenu(s)",
      value: `${nbAddedSections} ${pluralize(
        'contenu',
        nbAddedSections,
      )} ${pluralize('ajouté', nbAddedSections)}`,
    };
  }

  return {};
};
